/** Browser-side softphone preferences (the RingCentral-Embeddable-style settings
 *  that live entirely in the client). Persisted to localStorage so they survive a
 *  refresh; best-effort (private mode / quota degrades to defaults). No sensitive
 *  data — just the agent's own UX toggles. */
export interface CtiSettings {
  /** Answer incoming calls automatically after a short alert. */
  autoAnswer: boolean;
  /** Play an audible ring on incoming calls. */
  ringtone: boolean;
  /** Show a desktop (browser) notification on incoming calls. */
  notifications: boolean;
  /** Do Not Disturb — decline incoming calls without going offline. */
  dnd: boolean;
  /** Preferred microphone deviceId ("" = system default). */
  micDeviceId: string;
  /** Preferred speaker/audio-output deviceId ("" = system default). */
  speakerDeviceId: string;
}

export const defaultSettings: CtiSettings = {
  autoAnswer: false,
  ringtone: true,
  notifications: false,
  dnd: false,
  micDeviceId: "",
  speakerDeviceId: "",
};

const KEY = "ccv2.cti.settings";

export function loadSettings(): CtiSettings {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? { ...defaultSettings, ...(JSON.parse(raw) as Partial<CtiSettings>) } : defaultSettings;
  } catch {
    return defaultSettings;
  }
}

export function saveSettings(s: CtiSettings): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    /* quota / disabled → in-memory only */
  }
}
